import { EMPTY_VALUE } from '@src/core/config';

export const arcFormatLatitudeOrderCell = (value: string | number | null | undefined): string => {
  const n = Number(value);
  if (value == null || value === '' || Number.isNaN(n)) return 'N/A';
  return (n.toFixed(4) || EMPTY_VALUE) + '° N';
};

export const arcFormatLongitudeOrderCell = (value: string | number | null | undefined): string => {
  const n = Number(value);
  if (value == null || value === '' || Number.isNaN(n)) return 'N/A';
  return (n.toFixed(4) || EMPTY_VALUE) + '° E';
};

export const COORD_DISPLAY_DECIMALS = 6;

/** UI labels (details, cards): 6 decimal places — shared with confirm-order details. */
export const arcFormatCoordinateDisplay = (
  value: string | number | null | undefined,
  empty = 'N/A',
): string => {
  if (value == null || value === '') return empty;
  const n = Number(value);
  return Number.isFinite(n) ? n.toFixed(COORD_DISPLAY_DECIMALS) : empty;
};

/** Map markers / polylines: parse API string|number without rounding (use Number() only for display). */
export const arcToMapCoordinate = (value: string | number | null | undefined): number => {
  if (value == null || value === '') return NaN;
  const n = Number(value);
  return Number.isFinite(n) ? n : NaN;
};
